"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPackageInstanceCompleted = exports.isPackageInstanceCancelling = exports.containsUnlimitedSchedulers = exports.isUnlimitedScheduler = exports.hasUnlimitedSchedulersOnly = void 0;
const lodash_1 = require("lodash");
const isTierUnlimited = (tier) => {
    const tierContent = tier?.content;
    if (!tierContent) {
        return false;
    }
    const unlimitedSchedulerIds = tierContent?.unlimitedSchedulerIds ?? [];
    const allSchedulerIds = tierContent.schedulers ?? [];
    return (allSchedulerIds.length > 0 &&
        allSchedulerIds.every((id) => unlimitedSchedulerIds.includes(id)));
};
/**
 * It checks if all schedulers in a package instance, or a package template are unlimited.
 */
const hasUnlimitedSchedulersOnly = (packageData) => {
    if ("tier" in packageData && packageData.tier) {
        return isTierUnlimited(packageData.tier);
    }
    if ("tiers" in packageData && !(0, lodash_1.isEmpty)(packageData.tiers)) {
        return packageData?.tiers.every(isTierUnlimited);
    }
    const items = packageData.items;
    if ((0, lodash_1.isEmpty)(items)) {
        return false;
    }
    return items.every((item) => item?.isUnlimited);
};
exports.hasUnlimitedSchedulersOnly = hasUnlimitedSchedulersOnly;
const isUnlimitedScheduler = (packageData, schedulerId) => {
    if ("tier" in packageData && packageData.tier) {
        const tierContent = packageData?.tier.content;
        if (tierContent) {
            const unlimitedSchedulerIds = tierContent?.unlimitedSchedulerIds ?? [];
            return unlimitedSchedulerIds.includes(schedulerId);
        }
    }
    const items = packageData.items;
    if ((0, lodash_1.isEmpty)(items)) {
        return false;
    }
    return items.some((item) => item?.schedulerId === schedulerId && item?.isUnlimited);
};
exports.isUnlimitedScheduler = isUnlimitedScheduler;
/**
 * It checks if a package instance, or a package template contains unlimited schedulers.
 */
const containsUnlimitedSchedulers = (packageData) => {
    let schedulerIds = [];
    if ("tier" in packageData && packageData.tier) {
        const tierContent = packageData?.tier?.content;
        schedulerIds = tierContent?.schedulers ?? [];
    }
    if ("tiers" in packageData && !(0, lodash_1.isEmpty)(packageData.tiers)) {
        schedulerIds = packageData
            .tiers.map((tier) => tier?.content?.schedulers ?? [])
            .flat();
    }
    const itemsSchedulerIds = packageData?.items?.map((item) => item.schedulerId) ?? [];
    schedulerIds = [...schedulerIds, ...itemsSchedulerIds];
    return schedulerIds.some((id) => (0, exports.isUnlimitedScheduler)(packageData, id));
};
exports.containsUnlimitedSchedulers = containsUnlimitedSchedulers;
// Check if the package instance has been cancelled, but the last cycle is not over yet.
function isPackageInstanceCancelling(packageInstance) {
    return !!packageInstance.endDate && packageInstance.status !== "completed";
}
exports.isPackageInstanceCancelling = isPackageInstanceCancelling;
function isPackageInstanceCompleted(packageInstance) {
    return packageInstance.status === "completed";
}
exports.isPackageInstanceCompleted = isPackageInstanceCompleted;
//# sourceMappingURL=package-instances.js.map